<template lang='pug' src='./BookHolidayPopup.pug'></template>

<script>
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: 'BookHolidayPopup',
    data: function () {
      return {
        limitDaysText: 'Zero available days',
        holidaysText: {
          text_title: 'Book holiday',
          text_days: ' day(s), ',
          text_remaining: ' remaining',
          hint_add_days: 'Click last day'
        },
        holidaysBookedText: {
          text_title: 'Booked holiday'
        },
        publicText: {
          text_title: 'Mark as public holiday'
        },
        publicBookedText: {
          text_title: 'Public holiday'
        },
        newHolidayName: undefined
      }
    },
    props: {
      startDate: String,
      endDate: String,
      bookedDays: Number,
      isHolidaysCalendar: Boolean,
      editing: String,
      boxTop: Boolean,
      boxLeft: Boolean,
      workingDays: Number,
      holidayName: String,
      showOnly: Boolean
    },
    methods: {
      ...mapActions([
        'addHolidays',
        'cancelHolidays',
        'cancelRemove',
        'removeHolidays',
        'setHolidayName',
        'setApiError'
      ]),
      saveBooked () {
        this.setHolidayName(this.newHolidayName)
        this.addHolidays(this.isHolidaysCalendar)
        this.newHolidayName = undefined
      },
      cancelBooked () {
        if (this.showOnly) {
          this.$emit('show', false)
        }
        this.cancelHolidays(this.isHolidaysCalendar)
      },
      cancelRemoveHolidays () {
        if (this.getApiError) {
          this.setApiError()
        }
        this.cancelRemove()
      },
      removeBooked () {
        this.removeHolidays(this.isHolidaysCalendar)
      },
      canBeDeleted () {
        let now = new Date()
        now.setHours(0, 0, 0, 0, 0)
        return !this.isHolidaysCalendar || now < new Date(this.startDate)
      },
      isDisabled () {
        if (!this.isHolidaysCalendar) {
          return false
        }
        return this.getMe.remainingDays < 1
      }
    },
    computed: {
      ...mapGetters([
        'getMe',
        'getApiError'
      ]),
      end () {
        return this.startDate === this.endDate ? 'same day' : this.endDate
      }
    },
    updated () {
      this.setApiError('')
      this.$emit('show', false)
    }
  }
</script>

<style lang='css' src='./BookHolidayPopup.css' scoped></style>



// WEBPACK FOOTER //
// BookHolidayPopup.vue?d0906cc0